import React from "react";
import { Helmet } from "react-helmet";

import { BranchesRegistry } from "features/BranchesRegistry";
import { PageTitle } from "shared/ui/PageTitle";

const BranchesRegistryPage = () => {

    return (
        <>
            <Helmet title="Рестораны" />
            <PageTitle>Рестораны</PageTitle>
            <BranchesRegistry />
        </>
    );
};

export default BranchesRegistryPage;
